// Module
var code = "<svg xmlns=\"http://www.w3.org/2000/svg\" id=\"flag-icon-css-bd\" viewBox=\"0 0 640 480\"> <path fill=\"#006a4e\" d=\"M0 0h640v480H0z\"/> <circle cx=\"280\" cy=\"240\" r=\"160\" fill=\"#f42a41\"/> </svg> ";
// Exports
module.exports = code;